<style lang="scss" scoped="scoped">
	* {
		color: #303133;
	}

	.vue-grid-item {
		border: 1px solid #DCDFE6;
		// overflow: auto;
		box-sizing: border-box;
		position: relative;
		border-radius: 2px;
	}

	.vue-grid-item.vue-grid-placeholder {
		background: #419FFF !important;
	}

	.el-dropdown-link {
		cursor: pointer;
		color: #419FFF;
	}



	// .vue-grid-layout::-webkit-scrollbar {
	// 	width: 0 !important
	// }

	.module-grid {
		box-sizing: border-box;
	}
</style>
<style lang="scss">
	.el-popper {
		margin-right: 10px;
	}

	.homeIndex .organization .el-input__inner {
		color: #606266;
		border: none;
		background-color: transparent;
		text-align: right;
		width: 280px;
	}

	.homeIndex .organization .el-cascader .el-input .el-icon-arrow-down {
		color: #606266;

	}

	.homeIndex .organization .el-input__inner::-webkit-input-placeholder {
		color: #606266;
	}
</style>

<template>
	<div style="display: inline;">
		<div class="homeIndex" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
			<div ref="header" style="padding: 0px 24px  0px  24px;">
				<div class="module-grid"
					style="width: 100%;display: flex;justify-content: space-between;align-items: center;">

					<p style="font-size: 18px;">{{$t('huanyinghuilai')}}!{{store.state.user.nickname}}</p>
					<div style="display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
						<div class="organization" style="margin-top: 3px;display: flex;">
							<yi_data_select :type="'organization'" :ids.sync="orgId">
							</yi_data_select>

							<!-- <el-link style="margin-left: 40px;color: #419FFF;" icon="el-icon-edit">编辑看板</el-link> -->
						</div>
					</div>
				</div>
			</div>
			<div style="padding: 0px 4px 4px  4px;">
				<grid-layout v-if="gridContainerHeight!=0" :layout.sync="layout" :col-num="24" :maxRows="24"
					:row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false"
					:vertical-compact="true" :margin="[20, 20]" :use-css-transforms="true"
					:style="{'height': gridContainerHeight+'px'}" style="overflow: auto;">

					<grid-item :refs="'grid_'+item.i" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w"
						:h="item.h" :i="item.i" :key="item.i">
							<component v-bind:is="item.i" :orgId="orgId">
							</component>
					</grid-item>
				</grid-layout>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import VueGridLayout from 'vue-grid-layout';
	import alert from '@@/pages/web/home/alert';
	import about from '@@/pages/web/home/about';
	import produce from '@@/pages/web/home/produce';
	import status from '@@/pages/web/home/status';
	import alert_reason from '@@/pages/web/home/alert_reason';
	import quota from '@@/pages/web/home/quota';
	export default {
		name: 'web_home_index',
		components: {
			GridLayout: VueGridLayout.GridLayout,
			GridItem: VueGridLayout.GridItem,
			alert: alert,
			about: about,
			produce: produce,
			status: status,
			alert_reason: alert_reason,
			quota: quota,
		},

		data() {
			return {
				orgId: this.store.state.organizations[0].id,
				currentEquipment: {},
				gridContainerHeight: 0,
				gridRowHeihgt: 0,
				layout: [{
						"x": 0,
						"y": 0,
						"w": 11,
						"h": 8, //应该是6
						"i": "about"
					},

					{
						"x": 11,
						"y": 0,
						"w": 7,
						"h": 8, //应该是6
						"i": "produce"
					},
					{
						"x": 18,
						"y": 0,
						"w": 6,
						"h": 8,
						"i": "status"
					},
					{
						"x": 0,
						"y": 8,
						"w": 16,
						"h": 16,
						"i": "quota"
					},
					{
						"x": 16,
						"y": 6,
						"w": 8,
						"h": 8,
						"i": "alert"
					},
					{
						"x": 16,
						"y": 16,
						"w": 8,
						"h": 8,
						"i": "alert_reason"
					},


				],
			};
		},
		created() {

		},
		activated() {
			this.gridContainerHeight = this.gridContainerHeight+1
			this.resize()
		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		destroyed() {},
		methods: {



			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				//this.gridContainerHeight = 0
				setTimeout(() => {
					if (!this.$refs.header) {
						return;
					}
					//全屏this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 24
					this.gridContainerHeight = 800
					this.gridRowHeihgt = (this.gridContainerHeight - 500) / 24
				}, 500)

			},

		}
	};
</script>
